import React from 'react'
import styled from '@emotion/styled'
import { colors, font, radius, spacing } from '@mobi/component-library/Foundations'

export const ShareOptionButton: React.FC<React.PropsWithChildren<{ isBlocked?: boolean }>> = ({
  isBlocked,
  children,
}) => (
  <ShareOptionButtonStyled className={isBlocked ? 'share-option-button--blocked' : ''}>
    {children}
  </ShareOptionButtonStyled>
)

// ======
// Styles
// ======

const ShareOptionButtonStyled = styled.div({
  '> button': {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    height: '10rem',
    width: '100%',
    padding: spacing.sm,
    backgroundColor: colors.white,
    border: '0.1rem solid ' + colors.neutral[200],
    borderRadius: radius.lgx1,
    color: colors.neutral[900],
    fontFamily: font.family.primary,
    fontWeight: font.weight.medium,
    fontSize: font.size.lg.fontSize,
    letterSpacing: font.size.lg.letterSpacing,
    lineHeight: font.size.lg.lineHeight,
    WebkitTapHighlightColor: 'transparent',
    transition: 'all 0.15s ease-out',
    touchAction: 'manipulation',

    '@media (hover: hover) and (pointer: fine)': {
      ':hover': { backgroundColor: colors.neutral[100] },
      cursor: 'pointer',
    },

    ':active': {
      color: `color(from ${colors.black} srgb r g b / 0.5)`,
      backgroundColor: colors.neutral[300],
      scale: 0.95,
      opacity: 0.75,
    },

    '> span': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '3.6rem',
      height: '3.6rem',
      borderRadius: radius.full,
      backgroundColor: colors.lavender[100],
    },
  },

  '&.share-option-button--blocked > button': {
    backgroundColor: colors.neutral[200],
    borderColor: colors.neutral[300],
    color: colors.neutral[500],

    ':active': {
      scale: '1 !important',
      backgroundColor: colors.neutral[200],
      borderColor: colors.neutral[300],
      color: colors.neutral[500],
      opacity: 1,
    },

    '> div': {
      position: 'relative',

      '> span': {
        width: '100%',
        height: '100%',
        background: 'black',
        opacity: '50%',
        zIndex: 10,
        position: 'absolute',
      },
    },
  },
})
